import CreateGroupModal from '@pages/Admin/Manage/tabs/GroupsPage/components/CreateGroupModal/CreateGroupModal'

interface Props {
  isVisible: boolean
  directionId: number
  allowedFranchiseIds?: number[]
  onDismiss: () => void
  onCreate: (group: IGroup) => void
}

// Во всех точках создания группы используем одну форму и один контракт ответа.
const CreateLearningGroup = ({
  isVisible,
  directionId,
  allowedFranchiseIds,
  onDismiss,
  onCreate,
}: Props) => (
  <CreateGroupModal
    open={isVisible}
    directionId={directionId}
    allowedFranchiseIds={allowedFranchiseIds}
    onClose={onDismiss}
    onSuccess={() => {}}
    onGroupCreated={onCreate}
  />
)

export default CreateLearningGroup
